<template>
  <el-table-column
    prop="deputy_user.last_name"
    label="Területi képviselő helyettes"
    show-overflow-tooltip
    min-width="230"
    sortable="custom"
  >
    <template slot-scope="scope">
      <div style="display: inline-block;" v-if="scope.row.deputy_user">
        <el-link type="primary" @click="$router.push(`/users/view/${scope.row.deputy_user.id}`)">{{ scope.row.deputy_user.last_name }} {{ scope.row.deputy_user.first_name }}</el-link>
      </div>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'deputy_user.last_name',
  };
</script>
